const AuditConstants = {
  SET_VISIBLE_RANGE: 'AUDIT_SET_VISIBLE_RANGE',
  REFRESH: 'AUDIT_REFRESH',
  GET: 'AUDIT_GET',
  GET_SUCCESS: 'AUDIT_GET_SUCCESS',
  GET_FAIL: 'AUDIT_GET_FAIL',
  RELOAD: 'AUDIT_RELOAD',
  SET_FILTER: 'AUDIT_SET_FILTER',
  ACTIVATE_FILTER: 'AUDIT_ACTIVATE_FILTER',
  SET_ADVANCED_FILTER: 'AUDIT_SET_ADVANCED_FILTER',
  SET_SORTORDER: 'AUDIT_SET_SORTORDER',
  MODIFY_SELECTION: 'AUDIT_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'AUDIT_ALLOW_MULTI_SELECT',
  REMOVE_SUCCESS: 'AUDIT_REMOVE_SUCCESS',
  SAVE_SUCCESS: 'AUDIT_SAVE_SUCCESS',
  ENSURE_SELECTION_IS_VISIBLE: 'AUDIT_ENSURE_SELECTION_IS_VISIBLE',
  CLEAR: 'AUDIT_CLEAR',
  UPDATE: 'AUDIT_UPDATE',
  SET_SELECTION: 'AUDIT_SET_SELECTION',
  OPEN: 'AUDIT_OPEN',
  GET_FOR_OPEN_SUCCESS: 'AUDIT_GET_FOR_OPEN_SUCCESS',
  GET_BY_ID_SUCCESS: 'AUDIT_GET_BY_ID_SUCCESS',
  FIND_SUCCESS: 'AUDIT_FIND_SUCCESS',
};

export default AuditConstants;